import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MAdapter from "./MAdapter";
import { getShareMessage, urlFormatter, addMetricToObj } from "../utils/utils";

var BaiduMPAdapter = /*#__PURE__*/function (_MAdapter) {
  _inherits(BaiduMPAdapter, _MAdapter);

  var _super = _createSuper(BaiduMPAdapter);

  function BaiduMPAdapter() {
    var _this;

    _classCallCheck(this, BaiduMPAdapter);

    return _this = _super.call(this, ["https://s1.zhuanstatic.com/common/swan-2.0.22.js", "https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.4.35.js"], function () {
      _this.zzwa = window.zzwa;
      _this.__sdk = _this.zzwa; // WASDK初始化依赖jweixin
      // 由于WASDK是外链，部分魔方页会引用两个adapter，需兼容新adpater调老sdk的情况

      if (_this.__sdk.init) _this.__sdk.init(); // let ppu = getUrlParamsWithoutDecode().ppu;
      // if (ppu) {
      //   ppu = decodeURIComponent(ppu);
      //   if (ppu && !/^['|"]/.test(ppu)) {
      //     ppu = `"${ppu}"`;
      //   }
      //   setCookieOrigin('PPU', ppu)
      //   setCookieOrigin('ZZU', ppu)
      // }
    });
  }

  _createClass(BaiduMPAdapter, [{
    key: "share",
    value: function share() {
      this.zzwa.share(getShareMessage.apply(void 0, arguments));
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newObj = addMetricToObj(args[0]);
      var metric = newObj.metric,
          infoId = newObj.infoId;
      var newArgs = Object.assign([], args, [Object.assign({}, args[0], newObj)]);
      this.agentSkipToDetail(newObj, function () {
        var _this2$zzwa;

        (_this2$zzwa = _this2.zzwa).skipToDetail.apply(_this2$zzwa, _toConsumableArray(newArgs));
      });
    }
  }, {
    key: "skipToOrder",
    value: function skipToOrder() {
      var _this$zzwa;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var newObj = addMetricToObj(args[0]);
      var newArgs = Object.assign([], args, [Object.assign({}, args[0], newObj)]);

      (_this$zzwa = this.zzwa).skipToOrder.apply(_this$zzwa, _toConsumableArray(newArgs));
    }
  }, {
    key: "skipToUrl",
    value: function skipToUrl() {
      var _this$zzwa2;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var targetUrl = args[0].targetUrl;
      targetUrl = urlFormatter(targetUrl);
      var formatterArgs = Object.assign([], args, [Object.assign({}, args[0], {
        targetUrl: targetUrl
      })]);

      (_this$zzwa2 = this.zzwa).skipToUrl.apply(_this$zzwa2, _toConsumableArray(formatterArgs));
    }
  }]);

  return BaiduMPAdapter;
}(MAdapter);

export { BaiduMPAdapter as default };